import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  FormGroupLabel,
  FormItem,
} from "../../shared/components/form/FormElements";
import {
  ActionIconContainer,
  AddFormButton,
  CustomLoader,
} from "../../shared/components/TableElements";
import { formInputStyles } from "../../shared/constants/styles";

const SaveReportModal = ({ show, onClose, onSaveReport, saveBtnLoading }) => {
  const { t } = useTranslation("common");
  const [reportName, setReportName] = useState("");

  return (
    <Modal
      show={show}
      onHide={onClose}
      size="md"
      centered
      scrollable
      backdropClassName="custom-backdrop"
    >
      <Modal.Header>
        <h4>{t("save_report")}</h4>
        <div className="d-flex justify-content-end">
          <ActionIconContainer onClick={onClose}>
            <i className="fi fi-rr-cross-small" />
          </ActionIconContainer>
        </div>
      </Modal.Header>
      <Modal.Body className="m-0 p-0">
        <div>
          <div className="p-3 bg-white">
            <FormGroupLabel className="m-0">{t("report_name")}</FormGroupLabel>
            <FormItem>
              <input
                type="text"
                placeholder={t("report_name")}
                value={reportName}
                style={{ ...formInputStyles }}
                onChange={(e) => {
                  setReportName(e.target.value);
                }}
              />
            </FormItem>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <AddFormButton
          id="save-report-button"
          type="button"
          onClick={() => onSaveReport(reportName?.trim())}
          disabled={!reportName?.trim()}
        >
          {saveBtnLoading ? <CustomLoader /> : t("save")}
        </AddFormButton>
      </Modal.Footer>
    </Modal>
  );
};

export default SaveReportModal;
